import { Box, Flex, Icon, usePrefersReducedMotion } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

import Logo from '@/assets/icons/Logo';

const spin = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;

export const Loader = () => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const animation = prefersReducedMotion
    ? undefined
    : `${spin} infinite 1s ease`;
  return (
    <Box width="70px" height="70px" pos="relative">
      <Flex
        pos="absolute"
        top={0}
        left={0}
        alignItems="center"
        justifyContent="center"
        width="60px"
        height="60px"
        background="white"
        borderRadius="50%"
        borderTop="2px solid #3828AB"
        borderRight="2px solid #3828AB"
        borderBottom="2px solid #3828AB"
        borderLeft="2px solid transparent"
        animation={animation}
      />
      <Flex
        pos="absolute"
        top="5px"
        left="5px"
        bg="radial-gradient(50% 50% at 50% 50%, #608EFF 0%, rgba(78, 129, 255, 0) 100%)"
        alignItems="center"
        justifyContent="center"
        width="50px"
        height="50px"
        borderRadius="50%"
      >
        <Icon as={Logo} width="36px" height="36px" />
      </Flex>
    </Box>
    // <video
    //   autoPlay={true}
    //   muted
    //   loop
    //   style={{ width: '60px', pointerEvents: 'none' }}
    // >
    //   <source src="/static/loader.webm" type="video/webm" />
    //   {/* For unsupported browsers */}
    //   Loading...
    // </video>
  );
};
